import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import axios from "axios";
import { Dimmer } from "../components/spinner";
//import useTableScroll from "../../components/useTableScroll.js";

const CatalogoActividades = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const btnCancela = useRef();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N°",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCION",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "COD. ACTIVIDAD",
      textAlign: "center",
    },
  ];
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idactividad.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.codigoactividad
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarPersonasTodas = () => {
    let campos =
      "idactividad, trim(descripcion) as descripcion, trim(codigoactividad) as codigoactividad";
    let nomtab = "actividad";
    let orden = "idactividad";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    console.log(endpoint);
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var acti = [];
          for (let i = 0; i < response.data.length; i++) {
            acti.push({
              idactividad: response.data[i].idactividad,
              descripcion: response.data[i].descripcion,
              codigoactividad: response.data[i].codigoactividad,
            });
          }
          setRecords(acti);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setItemSelect("");
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarActividad = (index) => (event) => {
    var id = values[0].id;
    var desc = values[0].desc;
    var cod = values[0].cod;

    blanquear();
    props.onHideAceptaCatAct(id, desc, cod);
  };

  const seleccionarFila = (index) => (event) => {
    setActivo(false);
    setItemSelect(index);
    var id = recordsAfterPagingAndSorting()[index].idactividad;
    var desc = recordsAfterPagingAndSorting()[index].descripcion;
    var cod = recordsAfterPagingAndSorting()[index].codigoactividad;

    var datos = [];
    datos.push({
      id,
      desc,
      cod,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarPersonasTodas();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar Actividades</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row col-md-12" style={{ marginBottom: "2px" }}>
          <div className="input-group col-md-4 input-group-sm mb-3">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control"
            />
            <button className="btn btn-info" style={{ pointerEvents: "none" }}>
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.idactividad}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.descripcion}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.codigoactividad}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarActividad()}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
    </Modal>
  );
};

export default CatalogoActividades;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoActividades.js